import moment from 'moment'

export default {
  data () {
    return {
      rules: {
        required: v => (v !== null && v !== undefined && v !== '' && (!Array.isArray(v) || v.length > 0)) || this.$t('rules.required'),
        obligatorio: v => !!v || this.$t('rules.obligatorio'),
        email: v => (this.esVacio(v) || /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(v)) || this.$t('rules.email'),
        max: n => v => v == null || v.length <= n || this.$t('rules.max', { n }),
        min: n => v => v == null || v.length >= n || this.$t('rules.min', { n }),
        integerNumber0: v => (this.esVacio(v) || /^0*(?:[0-9]|[0-9]\d\d*)$/.test(v)) || this.$t('rules.integerNumber0'),
        integerNumber1: v => (this.esVacio(v) || /^0*(?:[1-9]|[1-9]\d\d*)$/.test(v)) || this.$t('rules.integerNumber0'),
        phoneNumber: v => (this.esVacio(v) || /^(\+?\d{2,3}?\s?)\0*(?:[0-9]|[0-9]\d\d*)$/.test(v)) || this.$t('rules.phoneNumber'),
        precioNumber: v => (this.esVacio(v) || /^\d((\d{0,2}(\.\d{3})*)+(,\d+)?)$/.test(v)) || this.$t('rules.precioNumber'),
        date: v => (this.esVacio(v) || this.validarFecha(v)) || this.$t('rules.date'),
        textOnly: v => (this.esVacio(v) || /^[a-zA-ZÀ-ÿ\u00f1\u00d1]*[a-zA-ZÀ-ÿ\u00f1\u00d1]+$/g.test(v)) || this.$t('rules.textOnly'),
        letterSpace: v => (this.esVacio(v) || /^[A-Za-z0-9\s]+$/g.test(v)) || this.$t('rules.letterSpace'),
        noNumbers: v => (this.esVacio(v) || /^[A-Za-zÀ-ÿ0-9\s]+$/g.test(v)) || this.$t('rules.letterSpace'),
        validarFormatoExcel: v => v === 'application/vnd.ms-excel'  || this.$t('rules.integerNumber0'),
        validarFormatoImagen: v => (v === '.image/jpg' || v === 'image/jpeg' || v === 'image/png') || this.$t('rules.integerNumber0'),
        mayor100: value => (this.esVacio(value) || value >= 100) || 'El número debe ser mayor que 100',
        menor50000: value => (this.esVacio(value) || value <= 50000) || 'El número debe ser menor que 50000',
        maxOperacion: v => v <= 250 || 'max. 250 caracteres',
        menor20000: value => (this.esVacio(value) || value <= 20000) || 'El número debe ser menor que 20.000',
        length02: value => (value.length === 0 || value.length === 2) || 'Debe seleccionar la fecha inicial y la fecha final'
      }
    }
  },
  methods: {
    esVacio (v) {
      return (v === null || v === '' || v === undefined)
    },
    validarFecha (v) {
      let auxV = moment(v, 'DD/MM/YYYY').format('YYYY-MM-DD')
      return moment(auxV).isValid()
    }
  }
}
